import { privateAPI } from '../../config/constants'
import { decrypt } from '../../functions/globalFunctions'

export const getVendorDetails = () => {
  return async () => {
    const res = await privateAPI.post(`/settings/get-vendor-details`)
    if (res) {
      let resp = decrypt(res.data)
      return resp?.data
    }
  }
}

export const UpdateVendor = (payload) => {
  return async () => {
    const res = await privateAPI.post(`/settings/update-vendor`, {
      data: {
        ...payload,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      return resp?.data
    }
  }
}
